module.exports = __webpack_public_path__ + "static/img/loginBG_A6301.74269e63.png";